import '../../../interactions/drag-move';
//# sourceMappingURL=index.js.map